/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/shared-ui/src/base/grid/css/grid';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '../elements/distribution-teaser-item/css/distribution-teaser-item';
import './distribution-teaser.scss';
